import axios from 'axios';

export async function extractImageToolError(err: unknown): Promise<string> {
    const e = err as { response?: { data: Blob | object } };

    if (e.response?.data instanceof Blob) {
        const text = await (e.response.data as Blob).text();

        try {
            const parsed = JSON.parse(text) as {
                errors?: Record<string, string[]>;
            };
            const messages = Object.values(parsed.errors ?? {}).flat();
            const msg = (messages[0] as string) || 'Request failed.';

            if (msg.toLowerCase().includes('imagick')) {
                return 'Image processing is not available on this server (Imagick). Please contact the administrator.';
            }

            return msg;
        } catch {
            return 'Request failed.';
        }
    }

    return 'Request failed.';
}

export function downloadBlob(blob: Blob, filename: string): void {
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(blobUrl);
}

export async function postImageToolForm(
    url: string,
    formData: FormData,
): Promise<{ blob: Blob; filename: string }> {
    const response = await axios.post(url, formData, {
        responseType: 'blob',
    });

    const cd = (response.headers['content-disposition'] as string) ?? '';
    const match = cd.match(/filename="?([^"]+)"?/);
    const filename = match?.[1] ?? 'download.bin';

    return { blob: response.data as Blob, filename };
}
